<script lang="ts">
  import { m } from '$lib/paraglide/messages.js';

  let visible = $state(false);

  $effect(() => {
    const handleScroll = () => {
      visible = window.scrollY >= 300;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  });

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
</script>

<button
  onclick={scrollToTop}
  class="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[999] w-10 h-10 md:w-12 md:h-12 rounded-full bg-warm-gold flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[#d4cabe] hover:scale-[1.08] {visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}"
  aria-label={m.scrolltop_aria()}
>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#0e0d0d" stroke-width="1.5">
    <path d="M10 16V4M10 4L4 10M10 4L16 10" />
  </svg>
</button>
